import React from "react";

const OrganizationListCell = (cellData) => {
  let list = cellData.data[cellData.column.dataField];
  return (
    <div>
      {(list && list.length > 0)
        ? list.map(({ id, name }) => <div key={id}>{name}</div>)
        : "Не указаны"}
    </div>);
};

function calculateString(list, sep = "") {
  let str = "";
  if (list && list.length > 0) {
    list.map(({name}, idx) => {
      str = str + name;
      if (idx < list.length - 1) {
        str += sep + " "
      }
    })
  }
  return str;
}

function organizationListCell(config, columnSpec) {
  let field = columnSpec.dataField;
  config.cellRender = OrganizationListCell;
  config.dataType = "string";
  config.calculateCellValue = (row) => {
    if (row[field]) {
      return calculateString(row[field]);
    } else {
      return null;
    }
  }
}

export {organizationListCell}
